import { maxUint256 } from 'viem'

export const MAX_APPROVE_AMOUNT = maxUint256
